import React, { useEffect, useState } from "react";
import { SendPostRequest } from "../../http";
import Spinner from "../Spinner";
import { capitalize } from "@mui/material";
import { useSelector } from "react-redux";
import { Modal, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import OwlCarousel from "react-owl-carousel";

// ✅ Helper to create truncated text with See More
const makeExcerpt = (html = "", limit = 130) => {
  const text = html.replace(/<[^>]*>/g, "").trim();
  if (text.length <= limit) return { excerpt: text, isLong: false };
  return { excerpt: text.slice(0, limit).trimEnd(), isLong: true };
};

function QuoteSliderReviews() {
  const sitedata = useSelector((store) => store.global.loginData);
  const [reviewsData, setReviewsData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [selectedReview, setSelectedReview] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    getReviewsData();
  }, []);

  const getReviewsData = async () => {
    try {
      setIsLoading(true);
      const response = await SendPostRequest("reviews");
      setReviewsData(response?.data || []);
    } catch (error) {
      console.error("Error fetching reviews:", error);
      setReviewsData([]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleShowMore = (review) => {
    setSelectedReview(review);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedReview(null);
  };

  return (
    <>
      {isLoading ? (
        <div className="d-flex justify-content-center my-5">
          <Spinner />
        </div>
      ) : reviewsData?.length === 0 ? (
        <h3 className="text-center my-5">No Reviews Available</h3>
      ) : (
        <div
          id="section-testimonial"
          className="section-testimonial section-bg-img bg-fixed mt-0 mb-4 o-visible"
          style={{
            backgroundImage:
              "url(/assets/images/mist/patient-reviews-centered-quote-slider.webp)",
            padding: "60px 0px",
          }}
        >
          <div className="overlay"></div>
          <div className="container" style={{ position: "relative", zIndex: 1 }}>
            <div className="row">
              <div className="offset-md-3 col-md-6">
                <div className="title-wrap text-center">
                  <div className="section-title margin-bottom-50">
                    <h2 className="section-title margin-top-5 text-uppercase typo-white mb-0">
                      Patient Reviews
                    </h2>
                    <span className="section-border-bottom center"></span>
                  </div>
                </div>
              </div>

              <div className="col-md-12">
                <OwlCarousel
                  className="owl-carousel testimonial-main-wrapper"
                  loop
                  nav={false}
                  dots={false}
                  autoplay={true}
                  autoplayHoverPause={false}
                  autoplayTimeout={3000}
                  smartSpeed={1000}
                  margin={30}
                  items={3}
                  responsive={{
                    0: { items: 1 },
                    768: { items: 2 },
                    1024: { items: 3 },
                  }}
                >
                  {reviewsData.map((data, index) => {
                    const { excerpt, isLong } = makeExcerpt(data?.detail, 110);
                    return (
                      <div className="item animated fadeInRight visible" key={data?.id || index}>
                        <div className="testimonial-style-2" style={{ height: "285px" }}>
                          <div className="testimonial-inner">
                            <div className="testimonial-details text-left">
                              <div
                                className="testimonial-description margin-top-15"
                                style={{
                                  minHeight: "140px",
                                  display: "flex",
                                  alignItems: "flex-start",
                                }}
                              >
                                <p className="mb-4 pb-1">
                                  {excerpt}
                                  {isLong && (
                                    <>
                                      ...{" "}
                                      <Link
                                        onClick={() => handleShowMore(data)}
                                        className="fw-bold"
                                        style={{ color: "#fff" }}
                                      >
                                        See More
                                      </Link>
                                    </>
                                  )}
                                </p>
                              </div>

                              <div className="client-details text-left left-align d-flex align-items-center">
                                <div className="client-image">
                                  <img
                                    className="img-circle"
                                    src={data?.profile_image || "/assets/img/no-image.png"}
                                    style={{ width: "65px", height: "65px" }}
                                    width="65"
                                    height="65"
                                    alt={data?.full_name || "reviewer"}
                                  />
                                </div>
                                <div className="client-info ms-3">
                                  <h4 className="mb-1" style={{ fontSize: "18px" }}>
                                    {data?.full_name}
                                  </h4>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </OwlCarousel>
              </div>
            </div>
          </div>

          {/* Modal for full review */}
          <Modal show={showModal} onHide={handleCloseModal}>
            <Modal.Header closeButton>
              <Modal.Title>Review Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {selectedReview && (
                <>
                  <p>{selectedReview?.detail}</p>
                  <div className="client-details text-left left-align d-flex align-items-center mt-4">
                      {/* <div className="client-image">
                        <img
                          className="img-circle"
                          src={selectedReview?.profile_image || "/assets/img/no-image.png"}
                          width="65"
                          height="65"
                          alt={selectedReview?.full_name || "reviewer"}
                        />
                      </div>
                      <div className="client-info ms-3">
                        <h4 className="mb-1">{selectedReview?.full_name}</h4>
                      </div> */}
                  </div>
                </>
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button variant="btn btn-default" onClick={handleCloseModal}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      )}
    </>
  );
}

export default QuoteSliderReviews;
